<template>
  <v-container
    grid-list-md
    fluid>
    <v-layout
      row
      wrap>
      <v-flex md12>
        <data-table ref="tableBitacora" />
      </v-flex>
    </v-layout>
  </v-container>
</template>
<script>
import DataTable from "@/views/bitacoras/monitorCorreos/DataTable";

export default {
  name: "MonitorCorreos"
  , components: { DataTable }
  , data() {
    let _locale = this.$store.language;
    return {
      locale: _locale
      , view: { title: this.$t("view.bitacoras.monitorCorreos.title") }
      , check: true
    };
  }
  , head: {
    title: function () {
      return {
        inner: this.view.title
        , separator: "|"
        , complement: this.$t("view.commons.system")
      };
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/views/bitacoras/monitorCorreos/MonitorCorreos.vue